export default __webpack_public_path__ + "static/media/Montserrat-ExtraBold.b824f09c.woff";